import { Injectable } from '@angular/core';
import { BaseHttpService, PageResponse } from './base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { AuthResponse, EncryptedData } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

export class Instance {
  id: number;
  uid: number;
  dafaultInstance: boolean;
  name: string;
  status: string;
  type: string;
}

@Injectable({
  providedIn: 'root'
})
export class InstanceService extends BaseHttpService {

  private readonly baseUrl: string;
  private urlEndPoint: string;

  constructor(client: HttpClient, snackBar: MatSnackBar) {
    super(client, snackBar);
    this.baseUrl = environment.server.mainURL
  }

  /**
   * fetches user default options, in this case the default instance stored in a token
   */
  async getUserDefaults() {
    this.urlEndPoint = this.baseUrl + 'defaults';
    return this.get<AuthResponse>(this.urlEndPoint);
  }

  async switchInstance(instance: number) {
    this.urlEndPoint = this.baseUrl + 'switch-instance/' + instance;
    return this.get<AuthResponse>(this.urlEndPoint);
  }

  async getUserInstances(page: number, size: number, defaultValue: boolean) {
    this.urlEndPoint = this.baseUrl + 'instance';
    const encrytedData = await this.get<EncryptedData>(this.urlEndPoint, { page: page, size: size, default: defaultValue });
    return this.decryptResponse<PageResponse<Instance>>(encrytedData.payload, this.KEY, encrytedData.iv);
  }

  async updateInstance(instance: Instance) {
    this.urlEndPoint = this.baseUrl + 'instance';
    let body = {
      payload: this.encrypt<Instance>(instance, this.KEY)
    }
    const encryptedData = await this.put<EncryptedData>(this.urlEndPoint, body);
    return this.decryptResponse<Instance>(encryptedData.payload, this.KEY, encryptedData.iv);
  }

  async createInstance(name: string) {
    this.urlEndPoint = this.baseUrl + 'instance';
    let body = {
      name: name
    };
    return this.post<AuthResponse>(this.urlEndPoint, body);
  }

  async deleteInstance(instanceId: number) {
    this.urlEndPoint = this.baseUrl + 'instance/' + instanceId;
    return this.delete<boolean>(this.urlEndPoint);
  }

}
